var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCode = function SvgCode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    clipRule: "evenodd",
    d: "M9.196 2.02a1 1 0 0 1 .785 1.176l-2 10a1 1 0 1 1-1.962-.392l2-10a1 1 0 0 1 1.177-.785Zm3.53 9.68a.999.999 0 0 1-1.428 0 .998.998 0 0 1 0-1.403L13.919 8l-2.631-2.297a.998.998 0 0 1 .327-1.625.999.999 0 0 1 1.1.222l2.637 2.447.21.195a1.498 1.498 0 0 1 0 2.116L12.726 11.7ZM3.274 4.3a.999.999 0 0 1 1.428 0 .998.998 0 0 1 0 1.403L2.081 8l2.631 2.297a.999.999 0 0 1-.327 1.625.999.999 0 0 1-1.1-.222L.647 9.253l-.21-.195a1.498 1.498 0 0 1 0-2.116L3.274 4.3Z"
  })));
};
export default SvgCode;